import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionLabel } from './ui/SectionLabel';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'How much do the herbs cost?',
  a: 'Most of the core "Sovereignty Stack" costs less than a daily cup of coffee when sourced in bulk through our directory.'
}, {
  q: 'Is this safe for my kids?',
  a: 'The protocol includes specific adjustments for pediatric sovereignty, focusing on gentle, non-toxic TCM foundations.'
}, {
  q: "I'm already on medication. Can I do this?",
  a: 'The protocol is designed to be a "Parallel System," but we include a full interaction guide for safety.'
}, {
  q: 'Do I need expensive equipment?',
  a: 'No. You need a shower, a kitchen, and the specific raw materials listed in the directory.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-16 bg-bio-black border-t border-bio-gray/30" data-id="element-63">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-64">
        <FadeIn data-id="element-65">
          <SectionLabel text="DATABASE // FREQUENTLY ASKED QUESTIONS" data-id="element-66" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-67">
            INTEL BRIEFING
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-68">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-69">
              <div className="border border-bio-gray/50 bg-bio-panel overflow-hidden" data-id="element-70">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-71">
                  <span className="font-bold text-white tracking-wide pr-8" data-id="element-72">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-bio-teal transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-73" />
                </button>

                <AnimatePresence data-id="element-74">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-75">
                      <div className="px-6 pb-5 pt-0 text-bio-muted font-light border-t border-bio-gray/30 mt-2 pt-4" data-id="element-76">
                        <span className="font-mono text-bio-teal text-xs mr-3" data-id="element-77">
                          A:
                        </span>
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}